export function compareValues(a, b) {
    if (typeof a === "string" && typeof b === "string") {
        return a.localeCompare(b, undefined, { sensitivity: "base", numeric: true })
    }
    if (a == null) return b == null ? 0 : -1
    if (b == null) return 1
    if (a < b) return -1
    if (a > b) return 1
    return 0
}
